import { StatesModule } from '@uirouter/angular';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { CoreNavigationTabsComponent } from '@fi-app/core/core-navigation-tabs/core-navigation-tabs.component';

export const FiCoreStates: StatesModule = {
    states: [
        {
            name: FiStateNames.Core._name,
            url: '/Core',
            component: CoreNavigationTabsComponent,
            resolve: {
                moduleModel: [FiCoreStatesResolve_moduleModel_resolveFunc],
            },
        },
    ],
};

export function FiCoreStatesResolve_moduleModel_resolveFunc() {
    return {
        ListData: null,
    };
}

export function registerCoreStateRules(
    stateAccessCheckService: StateAccessCheckService,
    userDataService: FiUserDataService,
) {
    stateAccessCheckService.registerStateRules([FiStateNames.User.List, FiStateNames.BusinessUnit.List], {
        SettingType: [
            ApplicationSettingsType.CoreGlobal,
            ApplicationSettingsType.CoreCentral,
            ApplicationSettingsType.CoreLocal,
        ],
        AccessType: AccessRightType.Read,
    });

    stateAccessCheckService.registerStateRules(
        [FiStateNames.User.Edit, FiStateNames.User.Add, FiStateNames.User.EditV2, FiStateNames.User.AddV2],
        {
            SettingType: [
                ApplicationSettingsType.CoreGlobal,
                ApplicationSettingsType.CoreCentral,
                ApplicationSettingsType.CoreLocal,
            ],
            AccessType: AccessRightType.Write,
        },
    );

    const idCheckFn = (params) => {
        if (params) {
            return userDataService.userData && userDataService.getUserId() == params.Id;
        }
        return false;
    };
    stateAccessCheckService.registerStateRules(
        [FiStateNames.User.Edit, FiStateNames.User.Add, FiStateNames.User.EditV2, FiStateNames.User.AddV2],
        <any>idCheckFn, // todo refactor
    );

    stateAccessCheckService.registerStateRules(
        [FiStateNames.BusinessUnit.Edit, FiStateNames.BusinessUnit.EditV2, FiStateNames.User.AccessRequests],
        {
            SettingType: [
                ApplicationSettingsType.CoreGlobal,
                ApplicationSettingsType.CoreCentral,
                ApplicationSettingsType.CoreLocal,
            ],
            AccessType: AccessRightType.Write,
        },
    );
    stateAccessCheckService.registerStateRules([FiStateNames.BusinessUnit.Add, FiStateNames.BusinessUnit.AddV2], {
        SettingType: [ApplicationSettingsType.CoreGlobal, ApplicationSettingsType.CoreCentral],
        AccessType: AccessRightType.Write,
    });

    stateAccessCheckService.registerStateRules(
        [
            FiStateNames.Area.List,
            FiStateNames.Area.View,
            FiStateNames.Area.Edit,
            FiStateNames.Cluster.List,
            FiStateNames.Cluster.View,
            FiStateNames.Cluster.Edit,
            FiStateNames.ExtendSharing.Edit,
        ],
        {
            SettingType: [ApplicationSettingsType.CoreGlobal],
            AccessType: AccessRightType.Admin,
        },
    );
    stateAccessCheckService.registerStateObjectType([FiStateNames.Area.View, FiStateNames.Area.Edit], ObjectTypes.Area);
    stateAccessCheckService.registerStateObjectType(
        [FiStateNames.Cluster.View, FiStateNames.Cluster.Edit],
        ObjectTypes.Cluster,
    );
}
